export default "__VITE_ASSET__CDqMnHQE__"